import z from 'zod'

export const applicationModel = z.object({
  __typename: z.literal('Application').default('Application'),
  id: z.string(),
  applicationKey: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  tag: z.array(z.string()),
  auth: z.object({
    request: z.object({
      password: z.boolean(),
      username: z.boolean(),
      grant_type: z.string(),
    }),
    application_auth_url: z.string(),
  }),
  requiresApiUser: z.boolean(),
  requiresEntityAccount: z.boolean(),
  metadata: z.record(z.string()),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
})

export type ApplicationModel = z.infer<typeof applicationModel>

export const applicationAuthModel = z.object({
  __typename: z.literal('ApplicationAuth').default('ApplicationAuth'),
  id: z.string(),
  applicationId: z.string(),
  subId: z.string().nullable(),
  clientKey: z.string(),
  secretData: z.string(),
  headers: z.object({}),
  metadata: z.object({}).nullable(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type ApplicationAuthModel = z.infer<typeof applicationAuthModel>
